import React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

import PreloadButton from '../../interface/PreloadButton';
import { useStores } from '../../hooks/use-stores';

const Product = observer(() => {
    const { ProfileOrderStore: store } = useStores();
    const { order, requestDocuments, requestAct, loaderRequestAct, loaderRequestDocuments } = store || {};
    const { id, products } = order || {};

    return (
        <div className="order mb-40">
            {/*<div className="order__title-img-wrap">*/}
            {/*<img*/}
            {/*    className="order__img"*/}
            {/*    src="https://www.arlift.ru/bitrix/templates/arlift/img/mini-cran-image-cat.jpg"*/}
            {/*    alt=""*/}
            {/*    role="presentation"*/}
            {/*/>*/}
            {/*</div>*/}
            {/*<div className="order__info">*/}
            {/*    <div className="order__header">*/}
            {/*        <div className="order__wrap-item">*/}
            {/*            <div className="order__key">Заказ</div>*/}
            {/*            <div className="order__value">*/}
            {/*                {id} от {moment(created_at).format('D.M.Y')}*/}
            {/*            </div>*/}
            {/*            <div className="order__wrap-item">*/}
            {/*                <div className="order__key">Сумма заказа</div>*/}
            {/*                <div className="order__value">{opportunity} руб.</div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="order__main-right">
                <div className="order__button">
                    <PreloadButton onClick={() => requestDocuments(id)} isLoad={loaderRequestDocuments}>
                        Запросить УПД
                    </PreloadButton>
                </div>
                <div>
                    <PreloadButton onClick={() => requestAct(id)} isLoad={loaderRequestAct}>
                        Запросить акт сверки
                    </PreloadButton>
                </div>
                {/*<PreloadButton onClick={() => repeatOrder(id)} isLoad={loaderRepeatOrder}>*/}
                {/*    Повторить заказ*/}
                {/*</PreloadButton>*/}
            </div>
            <div className="default-title-block mb-25">Комплектация</div>
            <div className="order__details">
                {products?.map(({ id, name, images, category_id }) => (
                    <Link to={`/catalog/${category_id}/${id}`} className="order__details-item" key={id}>
                        <div className="order__value">{name}</div>
                        {/*<div className="order__title-img-wrap">*/}
                        <img className="order__img" src={images && images[0]} alt="" role="presentation" />
                        {/*</div>*/}
                        {/*<div className="order__main">*/}
                        {/*<div className="order__main-left">*/}
                        {/*    <div className="order__wrap-item">*/}
                        {/*        <div className="order__key">Оплачено</div>*/}
                        {/*        <div className="order__value">14 000 руб.</div>*/}
                        {/*    </div>*/}
                        {/*    <div className="order__wrap-item">*/}
                        {/*        <div className="order__key">К оплате</div>*/}
                        {/*        <div className="order__value">20 000 руб.</div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="order__main-right">*/}
                        {/*    <div className="order__btn custom-btn">Оплатить заказ</div>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                        {/*<div className="order__footer">*/}
                        {/*    <div className="order__footer-left-col">Документы</div>*/}
                        {/*    <div className="order__footer-center-col">*/}
                        {/*        <div className="order__link">Скачать документы</div>*/}
                        {/*    </div>*/}
                        {/*    <div className="order__footer-right-col">*/}
                        {/*        <div className="order__link">Запросить акт сверки</div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </Link>
                ))}
            </div>
        </div>
    );
});
export default Product;
